import { createContext, useContext } from 'react'

// 전문가 토글의 상태. 컴포넌트(components/Expert.tsx)와 파일을 나눈 것은 fast refresh 규칙 때문이다.
export const ExpertCtx = createContext<{ on: boolean; toggle: () => void }>({ on: false, toggle: () => {} })

export function useExpert() {
  return useContext(ExpertCtx)
}
